import React from "react";
import { Skeleton, Paper, Table, TableBody, TableCell, TableRow, Box} from "@mui/material";

const STableLoader = ({ count = 8, rowCount = 15 }) => {
  return (
    <Paper className="lease-module-paper" elevation={0} sx={{ overflow: 'hidden' }}>
      <Table aria-labelledby="tableTitle" stickyHeader size="medium">
        {/* <TableHead>
          <TableRow>
            {Array.from({ length: count }).map((_, colIndex) => (
              <TableCell key={`header-${colIndex}`}>
                <Skeleton variant="rectangular" animation="wave" height={30} width="78%" sx={{margin:"0px auto"}} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead> */}
        <TableBody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <TableRow key={`row-${rowIndex}`} sx={{ backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#eef1ff"}}>
              {Array.from({ length: count }).map((_, colIndex) => (
                <TableCell key={`cell-${rowIndex}-${colIndex}`} >
                  <Box display="flex" justifyContent="center">
                 <Skeleton variant="rectangular" animation="wave" height={30} width="70%" sx={{margin:"5px 0"}} />
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default STableLoader;
